import { QuestionType, QuestionTypeEnum } from "./Question.Model";

export class QuestionHelper {
  public static getQuestionTypeList(): QuestionType[] {
    return [
      {
        typeEnum: QuestionTypeEnum.CODING,
        dl: "Coding and Problem-Solving",
      },
      {
        typeEnum: QuestionTypeEnum.MCQ,
        dl: "Quiz",
      },
      {
        typeEnum: QuestionTypeEnum.THEORETICAL,
        dl: "Theoretical",
      },
      {
        typeEnum: QuestionTypeEnum.HLD,
        dl: "High-Level Design",
      },
      {
        typeEnum: QuestionTypeEnum.LLD,
        dl: "Low-Level Design",
      },
      {
        typeEnum: QuestionTypeEnum.BEHAVIORAL,
        dl: "Behavioral",
      },
      {
        typeEnum: QuestionTypeEnum.MULTITHREADING,
        dl: "Multithreading",
      },
      {
        typeEnum: QuestionTypeEnum.DATABASE,
        dl: "Database",
      },
      {
        typeEnum: QuestionTypeEnum.OTHER,
        dl: "Other",
      },
    ];
  }
}
